import { useQuery } from '@tanstack/react-query';

import { eventConfigurationQueryOptions } from '@/queries/upgrade/eventConfiguration';

/** What every event was hardcoded to before the setting existed, and the fallback while it loads. */
export const DEFAULT_TIME_FORMAT = 'HH:mm';

/**
 * The event's time format as a date-fns format string - `time_format` on its configuration, which is
 * how an event switches between 24h ('HH:mm') and 12h ('hh:mm a').
 */
export function useEventTimeFormat(eventId: string | undefined): string {
  const { data: eventConfiguration } = useQuery(eventConfigurationQueryOptions(eventId));

  return eventConfiguration?.time_format || DEFAULT_TIME_FORMAT;
}

/**
 * Whether a date-fns format string prints a 12-hour clock: lowercase `h` is the 12-hour hour, `H` the
 * 24-hour one. Needed where a library takes an `hour12` flag instead of a format string.
 */
export function isTwelveHourFormat(timeFormat: string): boolean {
  return timeFormat.includes('h');
}
